goog.provide("shadow.js.shim.module$$mui$material$ListItem");
goog.provide("module$shadow_js_shim_module$$mui$material$ListItem");
shadow.js.shim.module$$mui$material$ListItem = shadow.js.nativeProvides["@mui/material/ListItem"] = shadow$bridge("@mui/material/ListItem");
module$shadow_js_shim_module$$mui$material$ListItem.default = shadow.js.shim.module$$mui$material$ListItem;
